<template>
	<div>
		<div class="firstDiv">
			<strong>{{ priceTxt }}:</strong>
			{{ ticket.grossprice | toDecimal }} {{ currencyTxt }}
		</div>
		<div>
			<strong>{{ ticketTypeTxt }}:</strong>
			{{ ticket.tickettype }} - {{ ticket.productoptions | getTicketType }}
		</div>
		<div class="lastDiv">
			<strong>{{ bookingDateTxt }}:</strong>
			{{ ticket.bookingdate | toDatetime }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'TicketDetailInfo',
	props: ['ticket'],
	data() {
		return {
			priceTxt: 'Preis (Brutto)',
			ticketTypeTxt: 'Ticket Typ',
			currencyTxt: 'EUR',
			bookingDateTxt: 'Ticket gebucht am ',
		}
	},
	filters: {
		toDate(value) {
			const date = new Date(value)
			return date
				.toDateString()
				.split(' ')
				.slice(1)
				.join('. ')
		},
		toDatetime(value) {
			try {
				const date = new Date(value)
				const year = date.getFullYear()
				let month = date.getMonth() + 1
				let day = date.getDate()
				let hours = date.getHours()
				let minutes = date.getMinutes()
				let seconds = date.getSeconds()

				// eslint-disable-next-line no-unused-expressions
				month < 10 ? (month = `0${month.toString()}`) : month.toString()
				// eslint-disable-next-line no-unused-expressions
				day < 10 ? day = `0${day.toString()}` : day.toString()
				// eslint-disable-next-line no-unused-expressions
				hours < 10 ? hours = `0${hours.toString()}` : hours.toString()
				// eslint-disable-next-line no-unused-expressions
				minutes < 10 ? minutes = `0${minutes.toString()}` : minutes.toString()
				// eslint-disable-next-line no-unused-expressions
				seconds < 10 ? seconds = `0${seconds.toString()}` : seconds.toString()
				const dateFormatted = `${year.toString()}-${month}-${day} ${hours}:${minutes}:${seconds}`
				return dateFormatted
			} catch (e) {
				return 'Date is not known'
			}
		},
		getTicketType(myjson) {
			let ticketType
			try {
				if (myjson.info_buyRequest && myjson.info_buyRequest.event && myjson.info_buyRequest.event.type) {
					ticketType = myjson.info_buyRequest.event.type.label
				} else if (myjson.event && myjson.event.type) {
					ticketType = myjson.event.type.label
				} else {
					throw new Error('No ticket type defined')
				}
				return ticketType
			} catch (e) {
				return 'ticketType could not be determined'
			}
		},
		toDecimal(value) {
			const number = Number(value)
			const result = number
				.toFixed(2)
				.toString()
				.replace('.', ',')
			return result
		},
	},
}
</script>

<style scoped>
.firstDiv {
  padding-top: 5px;
}
.lastDiv {
  padding-bottom: 5px;
}
.detailInfo {
  background-color: rgba(0, 2, 3, 0.3);
}
</style>
